import SignalContent from "../signal_content";
import VueStore from "../../../store/VueStore";
import router from "../../../router";
import { getSignallampComponentSetting } from "./get_signallamp_component_setting";
import { getSignallampSensorData } from "./get_signallamp_sensor_data";
import { changeSignallampFlash } from "./change_signallamp_flash";
import { applySetting } from "./apply_setting";
import { AuthStoreType, SignallampSensorData } from "../../../types/types";
import { getAndApplySetting } from "./update_and_get_and_apply_settings";
import { alarm, flashBackGround } from "./alarm";

// 最新データを取得する
export async function setLampFlash(
  self: SignalContent,
  authStores: AuthStoreType[],
) {
  if (VueStore.state.token === null) {
    return router.push("/signIn");
  }
  // コンポーネントの数だけ回る
  for (const key in authStores) {
    if (self.authStoreName === authStores[key].store_name) {
      const newSignallampSensorData: SignallampSensorData = await getSignallampSensorData(
        self,
        authStores[key],
      );
      changeSignallampFlash(self, newSignallampSensorData);
      await alarm(self, newSignallampSensorData);
      flashBackGround(self, newSignallampSensorData);
    }
  }
}

export async function signallampController(self: SignalContent) {
  if (VueStore.state.token === null) {
    return router.push("/signIn");
  }
  // 初回設定データ取得
  const componentApiResponse = await getSignallampComponentSetting(self);
  if (componentApiResponse.data.res.mst_signallamp_component_settings) {
    self.selectDeviceId = componentApiResponse.data.res.mst_signallamp_component_settings.select_device_id;
  }
  const settingApiResponse = await getAndApplySetting(self);
  if (self.mstSignallampComponent === null) {
    self.signalContent = false;
    self.optionContent = true;
    self.settingIcon = false;
    self.graphLoading = false;
  } else if (settingApiResponse !== null && settingApiResponse) {
    try {
      // 設定情報の適用
      applySetting(self, componentApiResponse);
      // 初回表示
      await setLampFlash(self, self.authStores);
      if (!self.errorCheck) {
        // 初回表示後の定期ループ
        self.reloadEvent = setInterval(function() {
          setLampFlash(self, self.authStores);
        }, 5000);
      }
    } catch (e) {
      console.error(e);
      self.graphLoading = false;
      // alert(self.$t("message.failedToGetLatestData"));
    }
  }
}
